import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';
import { ErrorComponent } from './shared/Components/error/error.component';
import { AuthGuard } from './shared/Services/auth.guard';
import { CustomUrlSerializer } from './shared/Services/custom-url-serializer.service';
import {PermissionGuard} from './shared/Services/permission-guard';
import { InvalidLinkComponent } from './shared/Components/invalid-link/invalid-link.component';
import { environment } from 'src/environments/environment';
import { Constant } from './shared/Constants/constant';
import { IndexComponent } from './vendor/index/index.component';
import { VendorModule } from './vendor/vendor.module';

const routes: Routes = [

  { path: 'error', component: ErrorComponent },
  { path: 'invalidlinkerror', component: InvalidLinkComponent },
  { path: "dashboard", loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardModule) , canMatch: [AuthGuard.canActivate]},
  { path: "auth", loadChildren: () => import('./core/core.module').then(m => m.CoreModule) },
  { path: "invite", loadChildren: () => import('./job-invite/job-invite.module').then(m => m.JobInviteModule) },
  // { path: "user", loadChildren: () => import('src/app/user/user.module').then(m => m.UserModule) , canMatch: [AuthGuard.canActivate]},
  { path: "user", loadChildren: () => import('src/app/vendor-user/user.module').then(m => m.UserModule) , canMatch: [AuthGuard.canActivate]},
  { path: 'jobrequest', loadChildren: () => import('./job-request/job-request.module').then(m => m.JobRequestModule) , canMatch: [AuthGuard.canActivate]},
  // { path: 'supplier', loadChildren: () => import('./supplier/supplier.module').then(m => m.SupplierModule), canMatch: [AuthGuard.canActivate]},
  { path: "supplier/group", loadChildren:()=>import('./supplier-group/supplier-group.module').then(m=>m.SupplierGroupModule), canMatch: [AuthGuard.canActivate]},
  { path: "jobseeker", loadChildren: () => import('src/app/job-seeker/job-seeker.module').then(m => m.JobSeekerModule) , canMatch: [AuthGuard.canActivate]},
  { path: "enterprise", loadChildren: () => import('src/app/Enterprise/enterprise.module').then(m => m.EnterpriseModule) , canMatch: [AuthGuard.canActivate]},
  { path: "supplier", loadChildren: () => import('src/app/vendor/vendor.module').then(m => m.VendorModule)},
  { path: "dsl", loadChildren: () => import('src/app/dsl/dsl.module').then(m => m.DslModule) },
  { path: "vs", loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: "report", loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
  // { path: '**', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  // { path: '**', loadChildren: () => import('./home/components/Virtusa/home//home.module').then(m => m.HomeModule) },

  // Dynamically load home module based on environment.client
  {
    path: '**',
    loadChildren: () => {
      // Check if the client is 'virtusa' and load the appropriate module
      return import('./home/home.module').then(m => m.HomeModule);
    }
  }
];
//, canMatch: [AuthGuard.canActivate]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
  ],
})
export class AppRoutingModule { }
